module.exports = __webpack_public_path__ + "assets/img/ground.f3ac430e.png";